import { ReactNode } from 'react';
import {
	StyledIconSlot,
	StyledLabel,
	StyledRow,
	StyledValueSlot,
} from './InputRow.styled';

interface IInputRowProps {
	label: ReactNode;
	icon?: ReactNode;
	children: ReactNode;
	className?: string;
}

const InputRow: React.FC<IInputRowProps> = ({
	label,
	icon,
	children,
	className,
}) => {
	return (
		<StyledRow className={className}>
			<StyledLabel>{label}</StyledLabel>
			<StyledValueSlot>
				{children}
				{icon && <StyledIconSlot>{icon}</StyledIconSlot>}
			</StyledValueSlot>
		</StyledRow>
	);
};

export { InputRow };
